import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import FormSeriesMedicalStep, { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import { PacemakerFormEvaluator, pacemakerFormQuestions } from "./ComposedPacemakerMedicalQuestions";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredPacemakerMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  FormSeriesMedicalStep({
    ...props,
    nextStep: Step.medicalRadiation,
    medicalQualificationEvaluator: PacemakerFormEvaluator,
    FormQuestions: pacemakerFormQuestions,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedPacemakerMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredPacemakerMedicalStep>
>({
  Component: ConfiguredPacemakerMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedPacemakerMedicalStep;
